import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {ChatbotService} from './chatbot.service';
import {WidgetChatbotComponent} from './widget-chatbot/widget-chatbot.component';

import {AuthenticationService} from '../shared/authentication';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  declarations: [
    WidgetChatbotComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [
    ChatbotService,
    AuthenticationService
  ],
  exports: [
    WidgetChatbotComponent
  ]
})
export class ChatbotModule {
}
